import { Box, TextField } from '@mui/material'

interface Props {
    value: string
    onChange: (value: string) => void
    label?: string
    placeholder?: string
}

const TableSearch = ({ value, onChange, label = 'Buscar', placeholder }: Props) => {

    return (
        <Box sx={{ marginBottom: '20px', maxWidth: '400px' }}>
            <TextField
                fullWidth
                label={label}
                variant="outlined"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'WorkSans',
                        fontSize: '14px',
                    },
                    '& .MuiInputLabel-root': {
                        fontFamily: 'WorkSans',
                        fontSize: '14px',
                    }
                }}
            />
        </Box>
    )
}

export const filterRows = <T,>(rows: T[], busqueda: string, fields: (keyof T)[]): T[] => {

    const texto = busqueda.trim().toLowerCase()
    if (texto === '') return rows

    return rows.filter(row =>
        fields.some(field => {
            const valor = (row as any)?.[field]
            return valor !== null && valor !== undefined && valor.toString().toLowerCase().includes(texto)
        })
    )
}

export default TableSearch
